<p-dialog header="Please enter your verification code" [(visible)]="ShowOTP" [style]="{width: '30vw'}" [baseZIndex]="10000"  [modal]="true">
    <div class="field mb-4 col-12" style="text-align: center;">
        <div class="field mb-4 col-12">
            <label for="otp" class="font-medium">To activate Waivers you will require a verification code, this has been sent to the email registered as the business owner on this account. Please check your email for this code.</label>
            <div class="otp-container" style="display: flex; align-items: center; gap: 10px; margin-top: 10px;">
                <div class="otp-group" style="display: flex; gap: 5px;">
                    <input #otp1 maxlength="1" class="otp-input otp-first" 
                            [(ngModel)]="otpCode[0]" 
                            (input)="onOtpInput($event, 0)" 
                            (keydown)="onOtpKeydown($event, 0)"
                            (paste)="onOtpPaste($event, 0)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; border-radius: 8px 0 0 8px; outline: none;
                                    transition: border-color 0.3s ease;" />
                    <input #otp2 maxlength="1" class="otp-input" 
                            [(ngModel)]="otpCode[1]" 
                            (input)="onOtpInput($event, 1)" 
                            (keydown)="onOtpKeydown($event, 1)"
                            (paste)="onOtpPaste($event, 1)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd;outline: none;
                                    transition: border-color 0.3s ease;" />
                    <input #otp3 maxlength="1" class="otp-input otp-last" 
                            [(ngModel)]="otpCode[2]" 
                            (input)="onOtpInput($event, 2)" 
                            (keydown)="onOtpKeydown($event, 2)"
                            (paste)="onOtpPaste($event, 2)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; border-radius: 0 8px 8px 0; outline: none;
                                    transition: border-color 0.3s ease;" />
                </div>
                <span style="font-size: 24px; font-weight: bold; color: #666; margin: 0 5px;">-</span>
                <div class="otp-group" style="display: flex; gap: 5px;">
                    <input #otp4 maxlength="1" class="otp-input otp-first" 
                            [(ngModel)]="otpCode[3]" 
                            (input)="onOtpInput($event, 3)" 
                            (keydown)="onOtpKeydown($event, 3)"
                            (paste)="onOtpPaste($event, 3)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; border-radius: 8px 0 0 8px; outline: none;
                                    transition: border-color 0.3s ease;" />
                    <input #otp5 maxlength="1" class="otp-input" 
                            [(ngModel)]="otpCode[4]" 
                            (input)="onOtpInput($event, 4)" 
                            (keydown)="onOtpKeydown($event, 4)"
                            (paste)="onOtpPaste($event, 4)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; outline: none;
                                    transition: border-color 0.3s ease;" />
                    <input #otp6 maxlength="1" class="otp-input otp-last" 
                            [(ngModel)]="otpCode[5]" 
                            (input)="onOtpInput($event, 5)" 
                            (keydown)="onOtpKeydown($event, 5)"
                            (paste)="onOtpPaste($event, 5)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; border-radius: 0 8px 8px 0; outline: none;
                                    transition: border-color 0.3s ease;" />
                </div>
            </div>
        </div>
    </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-lock" label="Submit Code" styleClass="p-button p-button-success" (click)="submitOtpCode()"></p-button>
  </ng-template>
</p-dialog>
<div class="agreement-container">

  <div *ngIf="!isLoading && agreement && currentPage" class="agreement-content">
    <div class="agreement-header">
      <h2>Agreement</h2>
      <div class="progress-container">
        <div class="progress-info">
          <span class="page-indicator">{{ getPageText() }}</span>
          <span class="progress-percentage">{{ getPageProgress() }}%</span>
        </div>
        <p-progressBar [value]="getPageProgress()" [showValue]="false" styleClass="custom-progress"></p-progressBar>
      </div>
    </div>

    <div class="page-content">
      <div class="page-text" [innerHTML]="currentPage.pagetext"></div>
  
      <div class="checkbox-container" *ngIf="currentPage.checkboxes && currentPage.checkboxes.length > 0">
        <div class="checkbox-section">
          <h4>Please read and agree to the following statement(s)</h4>
          <div *ngFor="let checkbox of currentPage.checkboxes; let i = index" class="checkbox-item">
            <div class="field mb-4 col-12">
                <label for="checkboxes" class="font-medium">{{checkbox.text}}</label>
                <p-selectButton [(ngModel)] = "checkbox.value" [style]="{'width': '150px'}" [options]="StateOptions" (onChange)="onSelectChange(this)"></p-selectButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isLastPage" [innerHTML]="authMessage" style="padding-left: 32px;padding-right:32px"></div>

    <div class="navigation-container">
      <div class="button-group">
        <button 
          pButton 
          type="button" 
          class="p-button-outlined p-button-secondary"
          [disabled]="isFirstPage"
          (click)="previousPage()">
          <span class="pi pi-angle-left" style="margin-right: 8px;"></span>
          Previous
        </button>

        <button 
          *ngIf="!isLastPage"
          pButton 
          type="button" 
          class="p-button p-button-primary"
          [disabled]="!allCheckboxesValid"
          (click)="nextPage()">
          Next
          <span class="pi pi-angle-right" style="margin-left: 8px;"></span>
        </button>

        <button 
          *ngIf="isLastPage"
          pButton 
          type="button" 
          class="p-button p-button-success"
          [disabled]="!allCheckboxesValid"
          (click)="saveAgreement()">
          <span class="pi pi-check" style="margin-right: 8px;"></span>
          I Authorize and Accept All Terms
        </button>
      </div>

      <div *ngIf="!allCheckboxesValid && currentPage.checkboxes.length > 0" class="validation-message">
        <i class="pi pi-exclamation-triangle"></i>
        All checkboxes must be selected to continue
      </div>
    </div>
  </div>

  <div *ngIf="!isLoading && !agreement" class="error-container">
    <div class="error-content">
      <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #ef4444;"></i>
      <h3>Agreement not found</h3>
      <p>The requested agreement could not be loaded.</p>
      <button pButton type="button" class="p-button" (click)="router.navigate(['/'])">
        Return to Home
      </button>
    </div>
  </div>
</div>
